export const formLabelStyles = {
  components: {
    FormLabel: {
      baseStyle: {
        marginBottom: "10px",
        // color: "red.dark",
      },
    },
  },
};
